import { Link } from "gatsby-plugin-react-i18next";
import React from "react";

const Promise = ({ promiseContent, differentStyle, promiseHeadline }) => {
  return (
    <section className={`m-promise ${differentStyle ? differentStyle : ""}`}>
      <div className="_wr">
        <div className="m-promise__topContent">
          <h2 className="m-promise__topContent--title">{promiseHeadline}</h2>
          <span className="a-line -red"></span>
        </div>
        <div className="_w m-promise__cardsContainer">
          {promiseContent.map(({ title, textOne, textTwo, icon, url, btnText }, i) => (
            <div className="_m4 m-promise__itemContent" key={i}>
              <div className="m-promise__item">
                <h3 className="m-promise__item--title">{title}</h3>
                <p className={`m-promise__item--text ${textTwo ? '' : '-solo'}`}>{textOne}</p>
                {textTwo ? (
                  <p className="m-promise__item--text">{textTwo}</p>
                ) : (
                  ""
                )}
                <div className="m-promise__item--icon">
                  {icon}
                </div>
                {url &&
                  <Link className="a-btn -redBorder a-hover -effectThree" to={url}>
                    {btnText}
                    <span className="a-arrow -long"></span>
                  </Link>
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Promise;
